import { render, staticRenderFns } from "./expertgroupTable.vue?vue&type=template&id=9edc2134&scoped=true"
import script from "./expertgroupTable.vue?vue&type=script&lang=js"
export * from "./expertgroupTable.vue?vue&type=script&lang=js"
import style0 from "./expertgroupTable.vue?vue&type=style&index=0&id=9edc2134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edc2134",
  null
  
)

export default component.exports